import { ReactNode } from "react";
import HeaderDialog from "./HeaderDialog";

function HeaderComposition({ children }: { children: ReactNode }) {
  return (
    <HeaderDialog>
      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        {children}
      </div>
    </HeaderDialog>
  );
}

export default HeaderComposition;
